
import React from "react";
import "./Home.css";
import Banner from '../banner/Banner.jsx';
import About from '../about/About.jsx';
import Events from '../events/Events.jsx';
import President from '../president/President.jsx';
import Gallery from '../gallery/Gallery.jsx';
import Memory from '../memory/Memory.jsx';
import Blog from '../blog/Blog.jsx';
import Contact from '../contact/Contact.jsx';



import Footer from '../footer/Footer.jsx';
import Login from "../login/Login.jsx";
import Members from "../members/Members.jsx";


function Home() {
    return (
      <section className="home" id="home">
        
        <Banner/>
        <About/>
        <Events/>
        <President/>
        <Gallery/>
        <Memory/>
        <Blog/>
        <Contact/>
       
      </section>
    );
  }
  
  export default Home;